/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontakteCom, FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontakteComFromJSONTyped, FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontakteComToJSON, } from './FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontakteCom';
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontakteComFromJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontakteComFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontakteComFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontakteCom(json)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontakteComFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontakteComToJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontakteComToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontakteComToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontakteCom(value)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontakteComToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontakteCom.js.map